import { createSlice } from '@reduxjs/toolkit'
import { modelTypes } from 'constants'
import { api, routes } from '@core/api'

const initialState = {
	products: window[modelTypes.productsToCompare]?.products ?? [],
}

function clearList(state) {
	state.products = []
}

function removeItem(state, action) {
	const { productId } = action.payload

	const prevState = [...state.products]

	const nextState = prevState.filter(product => product.id !== productId)

	state.products = nextState
}

const compareProductsSlice = createSlice({
	name: 'compareProducts',
	initialState,
	reducers: {
		clearCompareList: clearList,
		removeCompareItem: removeItem,
	},
})

export const { clearCompareList, removeCompareItem } = compareProductsSlice.actions

export function requestClearCompareProductsList() {
	return async dispatch => {
		dispatch(clearCompareList())

		await api.post(routes.comparelist.clearList)
	}
}

export function requestRemoveItemfromCompareList(productId) {
	return async dispatch => {
		await api.post(routes.comparelist.remove(productId))

		dispatch(removeCompareItem({ productId }))
	}
}

export function requestAddItemToCompareList(product) {
	return async () => {
		const { message, success } = await api.post(routes.comparelist.add(product.id))

		return new Promise((resolve, reject) => {
			if (success) {
				resolve({ message, success })
			} else {
				reject(new Error(message))
			}
		})
	}
}

export default compareProductsSlice.reducer
